import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, impressaoSegundaViaLicenciamento } from './types';

export const INITIAL_STATE: impressaoSegundaViaLicenciamento = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): impressaoSegundaViaLicenciamento {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRESSAO_SEGUNDA_VIA_LICENCIAMENTO_REQUEST: {
				break;
			}

			case Types.IMPRESSAO_SEGUNDA_VIA_LICENCIAMENTO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_SEGUNDA_VIA_LICENCIAMENTO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_SEGUNDA_VIA_LICENCIAMENTO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
